module.exports = __webpack_public_path__ + "static/media/foxnews.com_politics_elections_2016_presidential-election-headquarters_plot.9cddca44.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/foxnews.com_politics_elections_2016_presidential-election-headquarters_plot.png
// module id = 395
// module chunks = 0